export default __webpack_public_path__ + "static/media/education-11.79e465fb.svg";